import firebase_app from "../config";
import {
    getFirestore,
    query,
    collection,
    where,
    documentId,
    getDocs
  } from "firebase/firestore";

const db = getFirestore(firebase_app)
export default async function getByIDs(collectionName,ids) {
    const q = query(
        collection(db,collectionName),
        where(documentId(), "in", ids ),
      );
      
    const productsDocsSnap = await getDocs(q);
    const z = []
    productsDocsSnap.forEach((doc) => z.push({...doc.data(),id:doc.id}));
    return z
}



  
  